import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getCompanyUsers } from "actions/AccountManagementActions";
import { cn } from "utils/helpers";
import moment from "moment";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "components/RFQ/Table";
import { Icon } from "assets/Icon";
import { Button } from "../Button";
import { Link } from "@reach/router";
import { navigate } from "@reach/router";
import { SkeletonRow } from "components/SkeletonRow";
import { useCurrentCompanyId } from "hooks/auth";
import { USER_ROLE } from "newui/features/Auth/constants/UserRoleConstants";
export const AccountUsersComponent = ({ company_users, getCompanyUsers }) => {
	const [isLoading, setIsLoading] = useState(true);
	const companyId = useCurrentCompanyId();
	useEffect(() => {
		getCompanyUsers(companyId);
	}, [getCompanyUsers, companyId]);

	useEffect(() => {
		if (company_users && company_users.length >= 1) {
			setIsLoading(false);
		}
	}, [company_users]);

	const TableHeadComponent = ({ title, className }) => {
		return (
			<div
				className={cn("th font-roboto text-tertiary-600", className)}
				style={{ gap: "8px", alignItems: "center" }}
			>
				{title}
			</div>
		);
	};

	return (
		<>
			<div className="mb-5 mt-5 w-full rounded-lg border border-gray-200">
				<div className="mb-5 flex justify-between p-5">
					<div>
						<div className="font-roboto text-[18px] font-semibold text-primary-900">
							All Users
						</div>
						<p className="mt-2 font-roboto text-sm text-tertiary-600">
							Manage your company users and their account permissions here.
						</p>
					</div>

					<Button
						style={{ maxHeight: "48px" }}
						data-testid="create-new-user"
					>
						<Link
							className="flex items-center gap-[6px] text-white"
							to="create-user"
						>
							<div className="flex h-5 w-5 items-center justify-center">
								<Icon
									icon="plus"
									style={{
										width: "12px",
										height: "12px",
										color: "#fff",
										fontWeight: "bold",
									}}
								/>
							</div>
							<div className="font-roboto text-base font-semibold capitalize">
								Create User
							</div>
						</Link>
					</Button>
				</div>
				<Table className="border border-utility-gray-200">
					<TableHeader>
						<TableRow>
							<TableHead>
								<TableHeadComponent title="User"></TableHeadComponent>
							</TableHead>
							<TableHead>
								<TableHeadComponent title="Role"></TableHeadComponent>
							</TableHead>
							<TableHead>
								<TableHeadComponent title="Last Active"></TableHeadComponent>
							</TableHead>
							<TableHead>
								<TableHeadComponent title="Date Added"></TableHeadComponent>
							</TableHead>
							<TableHead>
								<TableHeadComponent title=""></TableHeadComponent>
							</TableHead>
						</TableRow>
					</TableHeader>
					<TableBody>
						{!isLoading &&
							company_users.map((user) => {
								return (
									<TableRow key={user?.id}>
										<TableCell className="w-[20%] overflow-hidden">
											<div className="flex items-center justify-start gap-2">
												<div className="font-roboto text-sm font-medium text-primary-900">
													<p className="font-semibold">{user?.full_name}</p>
													<p className="mb-1 font-roboto text-sm font-normal text-tertiary-600">
														<a
															href={`mailto:${user?.email}`}
															className="text-tertiary-600"
														>
															{user?.email}
														</a>
													</p>
													<p className="font-roboto text-sm font-normal text-tertiary-600">
														<a
															href={`tel:${user?.phone}`}
															className="text-tertiary-600"
														>
															{user?.phone}
														</a>
													</p>
												</div>
											</div>
										</TableCell>
										<TableCell>
											<div className="font-roboto text-sm font-normal capitalize text-tertiary-600">
												{user?.company_admin ? USER_ROLE.ADMINISTRATOR.label : USER_ROLE.USER.label}
											</div>
										</TableCell>
										<TableCell>
											{user?.last_activity
												? moment(user?.last_activity).format("DD/MM/YYYY")
												: "No Activity"}
										</TableCell>
										<TableCell>
											{user?.created_at
												? moment(user?.created_at).format("DD/MM/YYYY")
												: "--"}
										</TableCell>
										<TableCell>
											<Button
												className="flex gap-2 !px-4 !py-2"
												data-testid={`edit-user-${user?.id}`}
												onClick={() => {
													navigate("edit-user-account", {
														state: {
															user: user,
															company_users: company_users,
														},
													});
												}}
											>
												<Icon
													icon="edit"
													style={{ color: "#D0D5DD" }}
													className="cursor-pointer"
												/>
												Edit
											</Button>
										</TableCell>
									</TableRow>
								);
							})}
						{isLoading && (
							<>
								<SkeletonRow />
								<SkeletonRow />
								<SkeletonRow />
							</>
						)}
					</TableBody>
				</Table>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const company_users = state.accountManagement.companyUsers;
	return {
		company_users: company_users,
	};
};

export const AccountUsers = connect(mapStateToProps, { getCompanyUsers })(
	AccountUsersComponent
);
